<template>
  <section class="hero is-fullheight">
    <vue-particles
      id="tsparticles"
      @particles-loaded="particlesLoaded"
      :options="{
        fpsLimit: 120,
        interactivity: {
          events: {
            onClick: {
              enable: true,
              mode: 'push',
            },
            onHover: {
              enable: true,
              mode: 'grab',
            },
          },
          modes: {
            bubble: {
              distance: 400,
              duration: 2,
              opacity: 0.8,
              size: 40,
            },
            push: {
              quantity: 4,
            },
            repulse: {
              distance: 50,
              duration: 0.4,
            },
            grab: {
              distance: 200,
              duration: 0.4,
            },
          },
        },
        particles: {
          color: {
            value: '#ffffff',
          },
          links: {
            color: '#ffffff',
            distance: 150,
            enable: true,
            opacity: 0.5,
            width: 1,
          },
          move: {
            direction: 'none',
            enable: true,
            outModes: 'out',
            random: false,
            speed: 2,
            straight: false,
          },
          number: {
            density: {
              enable: true,
            },
            value: 50,
          },
          opacity: {
            value: 0.5,
          },
          shape: {
            type: 'circle',
          },
          size: {
            value: { min: 1, max: 3 },
          },
        },
        detectRetina: true,
      }"
    />
    <div class="hero-body">
      <div class="container has-text-centered">
        <div class="container column is-5 shdw">
          <!-- <h3 class="title has-text-white">{{ $t("log in") }}</h3> -->
          <!-- <hr class="login-hr" /> -->
          <div
            class="form box mb-0"
            ref="form"
            v-if="['system', 'database'].includes(authentication_method)"
          >
            <figure class="avatar">
              <img :src="logo" />
            </figure>
            <div class="field" v-show="!hide_enterprise">
              <p class="control is-expanded has-icons-left">
                <input
                  class="input is-large"
                  type="text"
                  :placeholder="$t('enterprise')"
                  v-model="enterprise"
                  name="enterprise"
                  @keyup.enter="login"
                />
                <span class="icon is-small is-left">
                  <i class="fa fa-building"></i>
                </span>
              </p>
            </div>
            <div v-if="method == 'user-password'">
              <div class="field">
                <p class="control is-expanded has-icons-left">
                  <input
                    class="input is-large"
                    type="text"
                    :placeholder="$t('username')"
                    v-model="username"
                    name="username"
                    @keyup.enter="login"
                  />
                  <span class="icon is-small is-left">
                    <i class="fa fa-user"></i>
                  </span>
                </p>
              </div>
              <div class="field">
                <p class="control is-expanded has-icons-left">
                  <input
                    class="input is-large"
                    type="password"
                    :placeholder="$t('password')"
                    v-model="password"
                    name="password"
                    @keyup.enter="login"
                  />
                  <span class="icon is-small is-left">
                    <i class="fa fa-key"></i>
                  </span>
                </p>
              </div>
              <!-- <div class="ui fluid primary large button" @click="login">
                {{ $t("log in") }}
                <i class="sign in icon" aria-hidden="true"></i>
              </div> -->
              <div class="columns mt-1">
                <div class="column">
                  <button
                    class="button is-primary is-rounded login-btn is-fullwidth"
                    @click="login"
                  >
                    <span class="icon">
                      <i class="fa fa-sign-in"></i>
                    </span>
                    <span>{{ $t("log in") }}</span>
                  </button>
                </div>
                <div class="column">
                  <button
                    class="button is-rounded is-fullwidth"
                    ref="lang_link"
                  >
                    <span class="icon">
                      <i class="fa fa-language"></i>
                    </span>
                    <div class="navbar-item has-dropdown is-hoverable">
                      <a class="navbar-link"> {{ $t("language") }} </a>

                      <div
                        class="navbar-dropdown"
                        ref="lang_dropdown"
                        style="background-color: black"
                      >
                        <a
                          class="navbar-item"
                          v-bind:class="{ 'is-selected': language == 'es' }"
                          @click="change_language('es')"
                        >
                          {{ $t("spanish") }}
                        </a>
                        <a
                          class="navbar-item"
                          @click="change_language('en')"
                          v-bind:class="{ 'is-selected': language == 'en' }"
                        >
                          {{ $t("english") }}
                        </a>
                        <a class="navbar-item"> {{ $t("french") }} </a>
                      </div>
                    </div>
                  </button>
                </div>
              </div>
            </div>
            <div v-if="method == 'face'">
              <face-login ref="face_login" @do_face_login="do_face_login" />
            </div>

            <div class="notification is-danger mt-5" v-if="error">
              <p v-html="error"></p>
            </div>
          </div>
          <!-- <div class="buttons"> -->
          <div
            class="button is-secondary is-info is-small is-rounded"
            @click="face_login"
            v-if="method == 'user-password'"
          >
            <span class="icon">
              <i class="fa fa-smile-o"></i>
            </span>
            <span class="ml-1">{{ $t("face login") }}</span>
          </div>
          <div
            class="button is-secondary is-info is-small is-rounded"
            @click="user_password_login"
            v-if="method == 'face'"
          >
            <span class="icon">
              <i class="fa fa-user"></i>
            </span>
            <span class="ml-1">{{ $t("username password login") }}</span>
          </div>
          <!-- </div> -->
          <p class="has-text-grey mt-3">
            <a @click="$refs.request_recovery_modal.show_modal">{{
              $t("forgot password")
            }}</a>
          </p>
        </div>
      </div>
    </div>
    <request-password-recovery-modal
      ref="request_recovery_modal"
      :enterprise="enterprise"
    />
  </section>
</template>

<script>
// import jssha1 from "js-sha1";
import RequestPasswordRecoveryModal from "./request_password_recovery_modal/Index.vue";
import FaceLogin from "./face_login/Index.vue";
import {
  post,
  get,
  generate_error_message_text,
  error_message,
  get_permissions,
  set_language,
  success_message,
} from "@/utils";

export default {
  name: "LoginView",
  components: { RequestPasswordRecoveryModal, FaceLogin },
  data() {
    return {
      enterprise: "",
      username: "",
      password: "",
      form: undefined,
      hide_enterprise: false,
      error: "",
      authentication_method: "system",
      language: "es",
      logo: "/img/modul/Modul-12t.png",
      method: "user-password", // or "face"
    };
  },
  methods: {
    login() {
      let v = this;
      // let isValid = window.jQuery(v.form).form("validate form");
      let isValid = v.enterprise && v.username && v.password;
      // console.log("isValid", isValid, v.enterprise, v.username, v.password);
      if (isValid) {
        v.$root.loader(true);
        // let pwd = jssha1(v.password);
        // if (v.authentication_method == "database") pwd = v.password;
        post("/system/authentication/login", {
          e: v.enterprise,
          u: v.username,
          p: v.password,
        })
          .then((r) => {
            // console.log("dsdfsdfsdf");
            if (r && r.token) {
              // console.log("r.token", r.token);
              localStorage.setItem("session_token", r.token);
            } else error_message(v.$t("no token received"));
            // console.log(localStorage.gsetItem("session_token"));

            if (r && r.user) {
              localStorage.setItem("user_data", JSON.stringify(r.user));
              localStorage.setItem("login_data", JSON.stringify(r));
              v.$emit("update_nav");
              if (
                r.user.settings &&
                r.user.settings.default_theme &&
                r.user.settings.default_theme != "dark"
              ) {
                import("bulma/css/versions/bulma-no-dark-mode.min.css")
                  .then(() => {
                    // CSS imported successfully
                  })
                  .catch((error) => {
                    // Handle CSS import error
                    console.error(error);
                  });
                if (!["dark", "light"].includes(r.user.settings.default_theme))
                  import(
                    "bulmaswatch/" +
                      r.user.settings.default_theme +
                      "/bulmaswatch.min.css"
                  )
                    .then(() => {
                      // CSS imported successfully
                    })
                    .catch((error) => {
                      // Handle CSS import error
                      console.error(error);
                    });
              }
            } else error_message(v.$t("no user data received"));

            if (r && r.permissions) {
              let perms = get_permissions();
              // console.log("perms", perms);
              localStorage.setItem(
                "permissions",
                JSON.stringify(r.permissions.concat(perms))
              );
            }

            if (r && r.shortkeys)
              localStorage.setItem("shortkeys", JSON.stringify(r.shortkeys));

            v.$root.loader(false);

            /** Language */
            if (
              r &&
              r.user &&
              r.user.settings &&
              r.user.settings.default_language
            )
              v.change_language(r.user.settings.default_language);
            else if (
              r &&
              r.user &&
              r.user.enterprise_settings &&
              r.user.enterprise_settings.default_language
            )
              v.change_language(r.user.enterprise_settings.default_language);

            /** Redirection */
            if (!r.user.last_login || r.user.must_change_password) {
              v.$router.replace({
                path: "/change-password",
              });
            } else {
              let previous_url = v.$route.query.redir;
              if (previous_url) {
                v.$router.replace(previous_url);
              } else {
                if (r && r.redirect_to) {
                  v.$router.replace({
                    path: r.redirect_to,
                  });
                } else
                  v.$router.replace({
                    path: "/home",
                  });
              }
            }
          })
          .catch((err) => {
            v.error = generate_error_message_text(err);
          })
          .finally(() => {
            v.$root.loader(false);
          });
      }
    },
    change_language(lang) {
      let v = this;
      set_language(v, lang);
    },
    particlesLoaded(/* container */) {
      // console.log("particlesLoaded", container);
    },
    face_login() {
      let v = this;
      v.method = "face";
      setTimeout(() => {
        v.$refs.face_login.start();
      }, 400);
    },
    user_password_login() {
      let v = this;
      v.method = "user-password";
    },
    do_face_login(dataURL) {
      let v = this;
      v.$root.loader(true);
      post("/system/authentication/face", {
        image: dataURL,
        enterprise: v.enterprise,
      })
        .then((r) => {
          // console.log("dsdfsdfsdf");
          if (r && r.token) {
            // console.log("r.token", r.token);
            localStorage.setItem("session_token", r.token);
          } else error_message(v.$t("no token received"));
          // console.log(localStorage.gsetItem("session_token"));

          if (r && r.user) {
            localStorage.setItem("user_data", JSON.stringify(r.user));
            localStorage.setItem("login_data", JSON.stringify(r));
            v.$emit("update_nav");
            if (
              r.user.settings &&
              r.user.settings.default_theme &&
              r.user.settings.default_theme != "dark"
            ) {
              import("bulma/css/versions/bulma-no-dark-mode.min.css")
                .then(() => {
                  // CSS imported successfully
                })
                .catch((error) => {
                  // Handle CSS import error
                  console.error(error);
                });
              if (!["dark", "light"].includes(r.user.settings.default_theme))
                import(
                  "bulmaswatch/" +
                    r.user.settings.default_theme +
                    "/bulmaswatch.min.css"
                )
                  .then(() => {
                    // CSS imported successfully
                  })
                  .catch((error) => {
                    // Handle CSS import error
                    console.error(error);
                  });
            }
          } else error_message(v.$t("no user data received"));

          if (r && r.permissions) {
            let perms = get_permissions();
            // console.log("perms", perms);
            localStorage.setItem(
              "permissions",
              JSON.stringify(r.permissions.concat(perms))
            );
          }

          if (r && r.shortkeys)
            localStorage.setItem("shortkeys", JSON.stringify(r.shortkeys));

          v.$root.loader(false);

          /** Redirection */
          let previous_url = v.$route.query.redir;
          if (previous_url) {
            v.$router.replace(previous_url);
          } else {
            if (r && r.redirect_to) {
              v.$router.replace({
                path: r.redirect_to,
              });
            } else
              v.$router.replace({
                path: "/home",
              });
          }

          /** Language */
          if (
            r &&
            r.user &&
            r.user.settings &&
            r.user.settings.default_language
          )
            v.change_language(r.user.settings.default_language);
          else if (
            r &&
            r.user &&
            r.user.enterprise_settings &&
            r.user.enterprise_settings.default_language
          )
            v.change_language(r.user.enterprise_settings.default_language);
        })
        .catch((error) => {
          this.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
  },
  mounted() {
    let v = this;
    localStorage.clear();
    v.form = window.jQuery(v.$refs.form).form({
      fields: {
        enterprise: ["empty"],
        username: ["empty"],
        password: ["empty"],
      },
      inline: true,
      on: "change",
    });

    if (process.env.NODE_ENV == "development") {
      v.enterprise = "modul";
      v.username = "lr";
      v.password = "admin";
    }

    v.$root.loader(true);
    get("/system/settings", {})
      .then((r) => {
        localStorage.setItem("system_settings", JSON.stringify(r));
        if (r && r.default_enterprise) v.enterprise = r.default_enterprise;
        if (r && r.hide_enterprise_field)
          v.hide_enterprise = r.hide_enterprise_field;
        if (r && r.free_use_urls)
          localStorage.setItem("permissions", JSON.stringify(r.free_use_urls));

        if (r.logo) v.logo = r.logo;

        // check for enterprise settings
        if (r && r.enterprise_settings) {
          if (r.enterprise_settings.default_language)
            v.change_language(r.enterprise_settings.default_language);
          if (r.enterprise_settings.authentication_method)
            v.authentication_method =
              r.enterprise_settings.authentication_method;
          // let enterprise_settings = r.enterprise_settings;
        } else {
          if (r && r.default_language) v.change_language(r.default_language);
        }

        if (r && r.run_init_modul_wizard) {
          success_message(
            v.$t(
              "welcome to modul, the wizard will guide you to initialize the platform"
            )
          );
          setTimeout(() => {
            v.$router.push({
              path: "/init-modul",
            });
          }, 2000);
        }
      })
      .catch((err) => {
        error_message(err);
      })
      .finally(() => {
        v.$root.loader(false);
      });

    window.jQuery(v.$refs.lang_link).click(function (/* e */) {
      window.jQuery(v.$refs.lang_dropdown).toggle();
    });
  },
};
</script>

<style scoped>
html,
body {
  font-family: "Questrial", sans-serif;
  font-size: 14px;
  font-weight: 300;
}
.shdw {
  /* border: 4px solid #ff000044; */
  border-radius: 20px;
  /* box-shadow: 0px 0px 10px 2px rgba(0, 209, 178, 0.5); */
  box-shadow: 0px 0px 300px 1px rgba(0, 209, 178, 0.4);
}
.hero {
  background: #000000;
  /* background: #333333; */
  /* background: #f1f1f1; */
}
.hero .nav,
.hero.is-success .nav {
  -webkit-box-shadow: none;
  box-shadow: none;
}
input {
  background-color: rgba(0, 0, 0, 0.5);
}
/* .box {
  margin-top: 5rem;
}
.avatar img {
  padding: 5px;
}
input {
  font-weight: 300;
}
p {
  font-weight: 700;
}
p.subtitle {
  padding-top: 1rem;
}

.login-hr {
  border-bottom: 1px solid black;
}

.has-text-black {
  color: black;
}

.field {
  padding-bottom: 10px;
}

.fa {
  margin-left: 5px;
} */

div.form.box {
  background-color: rgba(255, 255, 255, 0);
}

.login-btn {
  height: 55px !important;
}

.navbar-item {
  &.has-dropdown {
    .navbar-dropdown {
      display: none;
    }
    &.is-active {
      .navbar-dropdown {
        display: block;
      }
    }
  }
}
</style>
